import { Trans, useTranslation } from "react-i18next";
import PopupDialog from "src/SharedComponents/PopupDialog/PopupDialog";
import AuraIcon from "src/images/AuraBlackIcon.png";
import Button from "src/Components/Button/Button";
import { useNavigate } from "react-router-dom";

type IPaymentSuccess = {
    onClose: () => void;
}
const PaymentSuccess:React.FC<IPaymentSuccess> = ({onClose}) => {
    const { t } = useTranslation();
    const navigate = useNavigate(); 

    
    const handleInstallAppClick = () => {
        navigate('/app'); 
    };

    const handleInviteUserClick = () => {
        navigate('/users');
    }
    
    return (
        <div>
            <PopupDialog onClose={() => onClose()} marginTop="100px" popupWidth="30%">
                <div className="p-3 pb-5" style={{marginLeft: '20px'}}>
                    <div className="row mt-5">
                        <img src={AuraIcon} alt="aura" style={{width: '64px', margin: 'auto'}}/>
                    </div>
                    <div className="row mt-4 text-center">
                        <span style={{fontWeight: '600', fontSize: '20px'}}>
                            <Trans i18nKey="Congratulations"/>
                        </span>
                    </div>
                    <div className="row mt-2 text-center">
                        <span style={{fontWeight: '400', fontSize: '14px'}}>{t('PaymentSuccessfull')}</span>
                    </div>
                    <div className="row mt-5 text-center">
                        <span style={{fontWeight: '400', fontSize: '14px'}}>{t('NextSteps')}</span>
                    </div>
                    <div className="row mt-4 text-center">
                        <div>
                            <Button
                                height="40px"
                                backgroundColor="var(--color-primary-translucent)"
                                color="var(--color-primary)"
                                fontWeight="500"
                                fontSize="14px"
                                text={t('InstallAuraApp')}
                                onClick={handleInstallAppClick}
                            />
                        </div>
                    </div>
                    <div className="row mt-4 text-center">
                        <div>
                            <Button
                                height="40px"
                                backgroundColor="var(--color-primary-translucent)"
                                color="var(--color-primary)"
                                fontWeight="500"
                                fontSize="14px"
                                text={t('InviteOtherUsers')}
                                onClick={handleInviteUserClick}
                            />
                        </div>
                    </div>
                </div>
            </PopupDialog>
        </div>
    )
}

export default PaymentSuccess;